<template>
    <div class='apartment-wizard-form'>
        <InitialLoading :init-loading='initLoading'/>
        <v-container v-if='!initLoading'>
            <v-row>
                <!--header-->
                <v-col cols='12'>
                    <div class='d-flex align-center'>
                        <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>اطلاعات مجموعه خود را وارد کنید</h3>
                        <v-spacer/>
                        <v-btn outlined @click='goBack'>انصراف</v-btn>
                    </div>
                </v-col>
                <!--stepper-->
                <v-col cols='12'>
                    <v-stepper vertical v-model='step'>

                        <!--step 1 required data-->
                        <v-stepper-step ref='step-1' step='1' :complete='step > 1'>
                            ایجاد مجموعه با اطلاعات اولیه
                        </v-stepper-step>
                        <v-stepper-content step='1'>
                            <required-info v-model="apartment"
                                           :goToStep="goToStep"
                                           :step="step"/>
                        </v-stepper-content>

                        <!--step 2 InitManagerBalance-->
                        <v-stepper-step ref='step-2' step='2' :complete='step > 2'>
                            ثبت موجودی اولیه صندوق مجموعه
                        </v-stepper-step>
                        <v-stepper-content step='2'>
                            <managerBalance v-model="apartment"
                                            :goToStep="goToStep"
                                            :step="step"
                                            :supportRequest_id="apartment.supportRequest"/>
                        </v-stepper-content>

                        <!--step 3 submit Rules-->
                        <v-stepper-step ref='step-3' step='3' :complete='step > 3'>
                            ثبت قوانین مجموعه
                        </v-stepper-step>
                        <v-stepper-content step='3'>
                            <defineRules v-model="apartment"
                                         :goToStep="goToStep"
                                         :step="step"
                                         :supportRequest_id="apartment.supportRequest"/>
                        </v-stepper-content>

                        <!--step 4 complete apartment info-->
                        <v-stepper-step ref='step-4' step='4' :complete='step > 4'>تکمیل اطلاعات مجموعه</v-stepper-step>
                        <v-stepper-content step='4'>
                            <completeInfo v-model="apartment"
                                          :goToStep="goToStep"
                                          :step="step"
                                          :supportRequest_id="apartment.supportRequest"/>
                        </v-stepper-content>

<!--                        step 5 submit manager identity doc-->
                        <v-stepper-step ref='step-5' step='5' :complete='step > 5'>
                            ارسال مدارک هویتی مدیر مجموعه
                        </v-stepper-step>
                        <v-stepper-content step='5'>
                            <validationInfo v-model="apartment"
                                            :goToStep="goToStep"
                                            :step="step"
                                            :supportRequest_id="apartment.supportRequest"/>
                        </v-stepper-content>


                    </v-stepper>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex';

// import BankCardNumberInput from '@/components/BankCardNumberInput';
import {Icon} from 'leaflet';
// import InfoAlert from '@/components/Alerts/InfoAlert';
import InitialLoading from '@/components/initialLoading';
import requiredInfo from './formComponents/steps/requiredInfo';
import managerBalance from './formComponents/steps/managerBalance';
import defineRules from './formComponents/steps/defineRules';
import completeInfo from './formComponents/steps/completeInfo';
import validationInfo from './formComponents/steps/validationInfo';


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
export default {
    name: 'EditApartmentDetails',
    components: {
        InitialLoading,
        // InfoAlert,

        // BankCardNumberInput,
        requiredInfo,
        managerBalance,
        defineRules,
        completeInfo,
        validationInfo

    },
    data: () => ({
        supportRequest_id: null,


        photo: null,

        step: 1,
        initLoading: true,
        apartment_id: null,
        dialog: false,

        apartment: {
            _id: null,
            type: null,
            title: null,
            province: null,
            city: null,
            address: null,
            number: null,
            postalCode: null,
            floorCount: null,
            pieceCount: null,
            unitCount: null,
            blockCount: 1,
            photos: [],
            cover: null
        },

    }),
    methods: {
        showNavigationBar() {
            this.showNavigation(true);
        },
        goBack() {
            this.$store.commit('goBack');
            this.$router.replace(this.$store.state.history.page);
            this.showNavigationBar();
        },




        goToStep(step) {
            this.step = step;
            localStorage.setItem('step', this.step);
            // setTimeout(() => this.$vuetify.goTo(this.$refs[`step-${step}`], {offset: 10}), 400);
        },

        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    },
    async created() {
        this.supportRequest_id = localStorage.getItem('supportRequest_id');
        this.initLoading = false;
        await this.setBreadCrumbsTemp({
            key: 'createApartment',
            value: {
                text: `ایجاد مجموعه`,
                href: `/apartments/addApartment`
            }
        });
    },
    async updated() {
        await this.showBreadCrumbs(['home', 'createApartment']);
    },
    watch: {
        initLoading(val) {
            if (!val) {
                if (this.step > 1) {
                    setTimeout(() => {
                        const el = `step-${this.step}`;
                        const ref = this.$refs[el];
                        this.$vuetify.goTo(ref, {offset: 10});
                    }, 500);
                }
            }

        }
    },
    computed: {


        ...mapState(['user', 'public_url'])
    }
};
</script>

<style scoped lang='scss'>
.apartment-wizard-form {
    :deep().apartment-location {
        height: 200px;
        width: 100%;

        .vue2leaflet-map {
            z-index: 1;
            border-radius: 4px;
        }
    }


    :deep().ID-photo {
        grid-template-columns: repeat(2, 0.3fr);
    }

}

.rule-template-list {
    .item {
        :deep().v-input__slot {
            align-items: start;
        }
    }
}

:deep().quillWrapper {
    img {
        width: 40%;
        height: auto;
        @media screen and (max-width: 600px) {
            width: 100%;
        }
    }
}
</style>